// Тут знаходяться корисні функції.
/* global responsiveVoice */
import React from 'react';

function getWordsCount(phrase) {
	let a = phrase.split(' ').filter(v => { return v.length !== 0; });
	return a.length;
}

export default class CommonFunctions {
	static getDefaultDictionariesSettings() {
 		return (
			[
				{
					enabled: true,
					name: 'English phrases',
					spreadsheetUrl:
						'https://docs.google.com/spreadsheets/d/1qZB2EOGQPE8tyr9vvU3uBx1mVZNhh_KHxN2SHOLUE2s/edit#gid=0',
					skipFirstRow: false,
					phraseColumn: 'A',
					translationColumn: 'B'
				}
			]);
	}

	static getSpreadsheetId(url) {
		let r = url.match(/^https:\/\/docs.google.com\/spreadsheets\/d\/([^/]+)\//);
		if (r) return r[1];
		return null;
	}

	static getSetting(name, defaultValue) {
		let cookie = " " + document.cookie, find = " " + name + "=";
		let offset = cookie.indexOf(find);
		if (offset !== -1) {
			offset += find.length;
			let end = cookie.indexOf(";", offset);
			if (end === -1) end = cookie.length;
			return unescape(cookie.substring(offset, end));
		}
		return defaultValue === undefined ? null : defaultValue;
	}

	static saveSetting(name, value) {
		let d = new Date();
	    d.setFullYear(d.getFullYear() + 1); // Збільшуємо дату в d на рік.
		document.cookie =
				name + '=' + escape(value) + '; expires=' + d.toGMTString();
	}

	static speak(phrase, onEnd) {
		if (CommonFunctions.getSetting('useDefaultVoiceSettings', '1') === '1') {
			if (onEnd === undefined)
				responsiveVoice.speak(phrase);
			else
				responsiveVoice.speak(
						phrase,
						'UK English Female',
						{ onend: onEnd });
			return;
		}

		let parameters = {
				rate: CommonFunctions.getSetting('voiceRate', '1'),
				pitch: CommonFunctions.getSetting('voicePitch', '1'),
				volume: CommonFunctions.getSetting('voiceVolume', '1') };
		if (onEnd !== undefined) parameters.onend = onEnd;
		responsiveVoice.speak(
				phrase,
				CommonFunctions.getSetting('voice', 'UK English Female'),
				parameters);
	}

	static shuffleArray(array) {
		var currentIndex = array.length, temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
		return array;
	}

	// Фільтрує фрази по налаштуванні користувача.
	static filterPhrases(phrases) {
		if ((CommonFunctions.getSetting('filterPhrases', '1') === '0'))
			return phrases;

		let r = phrases;
		let minWordsInPhrase =
				CommonFunctions.getSetting('minWordsInPhrase', 'Unlimited');
		if (minWordsInPhrase !== 'Unlimited') {
			minWordsInPhrase = parseInt(minWordsInPhrase, 10);
			r = r.filter(v => {
				return getWordsCount(v[0]) >= minWordsInPhrase;
			});
		}

		let maxWordsInPhrase =
			CommonFunctions.getSetting('maxWordsInPhrase', '2');
		if (maxWordsInPhrase !== 'Unlimited') {
			maxWordsInPhrase = parseInt(maxWordsInPhrase, 10);
			r = r.filter(v => {
				return getWordsCount(v[0]) <= maxWordsInPhrase;
			});
		}

		return r;
	}

	static createSelectOptions(array) {
		return array.map((v, i) => <option key={i}>{v}</option>);
	}

	// Return array of string values, or null if csv string is not well formed.
	static csvToArray(text) {
		var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
		var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;

		// Return null if input string is not well formed csv string.
		if (!re_valid.test(text)) return null;

		var a = []; // Initialize array to receive values.
		text.replace(re_value, // Walk the string using replace with callback.
			function(m0, m1, m2, m3) {
				// Remove backslash from \' in single quoted values.
				if      (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
				// Remove backslash from \" in double quoted values.
				else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
				else if (m3 !== undefined) a.push(m3);
				return ''; // Return empty string.
			});
		// Handle special case of empty last value.
		if (/,\s*$/.test(text)) a.push('');
		return a;
	} // csvToArray
}



// WEBPACK FOOTER //
// ./src/CommonFunctions.js